import { z } from "zod";
import { CONTACT_STATUS } from "@features/helpdesk/constants";
import { reqNonpaidReportGameSchema } from "@features/helpdesk/model/getNonpaidReportGamesModel";

const badUserComplaintIDSchema = z.number();
// 신고 상태 코드 validation
const badUserComplaintStateSchema = z.nativeEnum(CONTACT_STATUS);

// 개별 신고 항목 스키마
const nonpaidReportsItemSchema = z.object({
  badUserComplaintID: badUserComplaintIDSchema,
  badUserComplaintStateCode: badUserComplaintStateSchema,
  registerDate: z.string(),
  occurStartDate: z.string(),
  serviceCode: z.number(),
  lossAmount: z.number(),
  serviceName: z.string(),
});

const paginationSchema = z.object({
  page: z.number(),
  size: z.number(),
});

// 페이지네이션 스키마
const paginationsSchema = paginationSchema.merge(
  z.object({
    total: z.number(),
    endPage: z.number(),
  }),
);

// 전체 배열 스키마
export const getNonpaidReportsSchema = z.object({
  pagination: paginationsSchema,
  items: z.array(nonpaidReportsItemSchema),
});
export const reqNonpaidReportsSchema = paginationSchema.merge(reqNonpaidReportGameSchema);

// 상세 report 스키마
const nonpaidReportItemSchema = z.object({
  lossAmount: z.number(),
  badUserComplaintID: badUserComplaintIDSchema,
  serviceCode: z.number(),
  icafeId: z.string(),
  occurStartDate: z.string(),
  badUserComplaintStateCode: badUserComplaintStateSchema,
  occurEndDate: z.string(),
  phoneNumber: z.string(),
  badUserIP: z.string(),
  badUserComplaintContent: z.string(),
  adminAccount: z.string(),
  changeDate: z.string(),
  registerDate: z.string(),
});

// 상세 스키마
export const getNonpaidReportSchema = z.object({
  personName: z.string(),
  serviceName: z.string(),
  report: nonpaidReportItemSchema,
  bizOwnerRegisterNumber: z.string(),
  companyName: z.string(),
});

// 타입 추론
export type badUserComplaintIDType = z.infer<typeof badUserComplaintIDSchema>;
export type GetNonpaidReportsType = z.infer<typeof getNonpaidReportsSchema>;
export type GetNonpaidReportType = z.infer<typeof getNonpaidReportSchema>;
export type ReqNonpaidReportsType = z.infer<typeof reqNonpaidReportsSchema>;
